export default __webpack_public_path__ + "static/media/img7.1ee7123a.jpg";